import React from 'react'
import '../styles/style.css'
import back from '../images/back.svg'
import apiUrls from '../common/apiUrls';
import { getContentHeaders, getGetApi } from '../common/axiosConfig';
import Loader from '../common/loader'
class About extends React.Component {

    constructor (props){
        super(props);
        this.state={
            showLoader:false,
            content : ""
        }
    }
    componentDidMount = ()=>{
        this.getAboutUs();
    }
    goBack = () =>{
        this.props.history.goBack()
    }
    showLoader = () =>{
        this.setState({showLoader:true});
    }
    hideLoader = () =>{
        this.setState({showLoader:false});
    }

    getAboutUs = () =>{
        this.showLoader();
        getGetApi(apiUrls.aboutus,getContentHeaders()).then((response)=>{
            this.setState({showLoader:false});
            if(response.data.code == 2000){

               this.setState({contentFetched:response.data.data.contentFetched[0].desciption});
            }
        })
    }

    render() {

        return (
            <div className="container-bmi">
                {this.state.showLoader && <Loader></Loader>}
                <div className="header-bmi ee">
                    <img src={back} onClick={this.goBack}></img>
                    <p>About Service</p>
                </div>
                <div className="content-about">
                    <p className="about-desc" dangerouslySetInnerHTML={{
                    __html: this.state.contentFetched
                }}>
                        
                    </p>
                </div>
            </div>
        );
    }
}

export default About;